<script setup lang="ts">
import { formatNumber } from '@/home/utils/format'
import type { HotRepo } from './hot';
const props = defineProps<HotRepo>();
</script>

<template>
  <div class="h-52 flex-col justify-between">
    <div class="flex justify-between">
      <a :href="props.jump" target="_blank">
        <h3 class="max-w-372 truncate text-16 c-hex-292929 font-500 leading-28 hover:underline">
          {{ props.name }}
        </h3>
      </a>
      <div class="mb-auto mt-auto flex gap-4 bg-transparent c-hex-575757">
        <div class="i-icons:star size-16"></div>
        <span class="text-12 font-400 leading-16">
          {{ formatNumber(props.starCount) }}
        </span>
      </div>
    </div>
    <p class="max-w-372 truncate text-14 c-hex-575757 leading-22">
      {{ props.description }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
</style>
